module.exports = __webpack_public_path__ + "img/fullscreen-exit.4478f883.svg";